
import './registrationScrutiny.css'
import { useNavigate } from "react-router-dom";

import { GET_MAPPING_DETAILS, GET_USER_DETAILS, GET_ALL_STAKEHOLDERS, STAKEHOLDER_COUNT } from '../../../common/URLs';
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { OTPValidationPopover } from '../../../preregcamps/confirmPopover/otpValidationPopover';
import { DialogContent, Dialog, Tooltip, IconButton } from '@mui/material';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD, ROLES } from '../../../common/constants';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { getUserDetails } from '../../../common/Utils';
import Link from "@mui/material/Link";
import { lastFiveDigitsComparator } from '../../../common/commonFunction';
import { loaderService } from '../../../common/custom-loader/loader-service';
import apiClient from '../../../axios';
import { UpdateIcon } from '../../../common/icons';

function RegistrationScrutiny() {
    const [emailId, setEmailId] = useState(localStorage.getItem('InspectorEmail'));
    const [userId, setUserId] = useState(localStorage.getItem('uuid'));
    const [role, setRole] = useState(localStorage.getItem('role'));
    const [userDetails, setUserDetails] = useState();
    const [mappingDetails, setMappingDetails] = useState();
    const [stakeHolders, setStakeHolders] = useState();
    const [stakeHolderSubCategory, setStakeHolderSubCategory] = useState();
    const [stakeholderType, setStakeholderType] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [urn, setUrn] = useState();
    const [mobileNumber, setMobileNumber] = useState();
    const [editMode, setEditMode] = useState();

    const blockScrutinizersArray = process.env.REACT_APP_BLOCK_SCRUTINIZERS_FROM_REGISTERING.split(',')

    function viewAllAssignedStakeholders(e, resourceUpdate) {
        e.preventDefault();
        navigate("/registrationHome/dashboard/viewAllAssignedStakeholders", { state: { userid: userId, isResourceUpdate: resourceUpdate } });
    }
    function viewAllClarifications(e, resourceUpdate) {
        e.preventDefault();
        navigate("/registrationHome/dashboard/viewAllClarifications", { state: { userid: userId, isResourceUpdate: resourceUpdate } });
    }
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        getUserDetails(emailId, setUserDetails);
    }, []);
    // const updateUserDetails = (response) => {
    //     setUserDetails(response);
    // }
    const onRegister = (urn, mobileNumber, subCategory, stakeHolderType, editmode) => {
        setStakeHolderSubCategory(subCategory);
        setStakeholderType(stakeHolderType);
        setUrn(urn);
        setMobileNumber(mobileNumber);
        setEditMode(editmode);
        handleLogModalOpen();
    }
    const onView = (urnSelected, stakeholderType, growerSubCategory) => {
        const userData = {
            "urnSelected": urnSelected,
            "userId": userId,
            "isScrutinyView": true

        }
        if (stakeholderType === "Transporter") {
            navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (stakeholderType === "HIT") {
            navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (stakeholderType === "LLE") {
            navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (stakeholderType === "Interim Storage Operator") {
            navigate("/registrationHome/dashboard/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
            navigate("/registrationHome/dashboard/registrationDetails", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || stakeholderType === "FPC" || growerSubCategory === "FPC") {
            navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (growerSubCategory === "Forest") {
            navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else {
            // navigate("/registrationHome/dashboard/onView", { state: { data: userData } });
        }

    }
    const onOTPValidated = (urn, onClose) => {
        onClose();
        if (stakeHolderSubCategory == "Grower" || stakeHolderSubCategory == "Individual" || stakeHolderSubCategory == "JFMC" || stakeHolderSubCategory === "Other Agency") {
            navigate("/registrationHome/dashboard/registrationDetails", { state: { URN: urn, editmode: editMode } });
        }
        else if (stakeHolderSubCategory == "Forest") {
            navigate("/registrationHome/dashboard/personalDetailsForest", { state: { URN: urn, editmode: editMode } })
        } else if (stakeHolderSubCategory === "Co-operative" || stakeHolderSubCategory === "FPO" || stakeHolderSubCategory === "SHG" || stakeHolderSubCategory === "FPC") {
            navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { URN: urn, stakeHolderSubCategory: stakeHolderSubCategory, editmode: editMode } })
        }
        else if (stakeHolderSubCategory === "Forest") {
            navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { URN: urn, stakeHolderSubCategory: stakeHolderSubCategory, editmode: editMode } })
        }
        else if (stakeholderType === "HIT") {
            navigate("/hitRegistration", { state: { URN: urn } })
        }
        else if (stakeholderType === "Transporter") {
            navigate("/hitRegistration", { state: { URN: urn } })
        }
        else if (stakeholderType === "LLE") {
            navigate("/lleMainPage", { state: { URN: urn } })
        }
        else if (stakeholderType === "Interim Storage Operator") {
            navigate("/hitRegistration", { state: { URN: urn } })
        }
    }
    useEffect(() => {
        if (userId) {
            getMappingDetails();
        }
    }, [userId]);
    const pendingAppCount = userDetails?.applicationStatusCount?.[0]?.count;
    const pendingClarificationsCount = userDetails?.applicationStatusCount?.[1]?.count;
    const resourceUpdateCount = userDetails?.applicationStatusCount?.[2]?.count;
    const resourceUpdatePendingClarificationCount = userDetails?.applicationStatusCount?.[2]?.count;
    const userType = userDetails?.user?.userType

    function getMappingDetails() {
        loaderService.showLoader();
        apiClient
            .post(GET_MAPPING_DETAILS,
                {
                    "userID": userId,
                    "userRole": localStorage.getItem('role'),
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                loaderService.hideLoader();
                setMappingDetails(response.data);
            })
            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });
    }
    const mappingArray = mappingDetails?.scrutinizermappings;
    const columns = [
        {
            field: 'id', headerName: 'S.No', width: 60,
            renderCell: (index) => index.api.getRowIndex(index.row.urn) + 1
        },
        {
            field: 'urn', headerName: 'URN', width: 200, sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
            renderCell: (params) => {
                if (getLocalStorageItem('role') === ROLES?.RegAssistant || getLocalStorageItem('role') === ROLES?.RegSuperVisor || (getLocalStorageItem('role') === ROLES?.RegistrationScruitnizer && userType === "External")) {
                    return params.value
                }
                else return (<Link to={params} onClick={() => { onView(params?.row?.urn, params?.row?.stakeholderType, params?.row?.stakeholderSubCategory) }}>{params.value}</Link>)
            }
        },
        { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 200 },
        { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
        { field: 'curentOwner', headerName: 'Current Owner', width: 200 },
        { field: 'lastUpdatedDate', headerName: 'Last Updated Date', width: 200 },
        {
            field: 'isRegistered', headerName: 'Reg. Completed', width: 200,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Yes';
                }
                else {
                    return 'No';
                }
            }
        },
        { field: 'status', headerName: 'Status', width: 200 },
        { field: 'scutinyStatus', headerName: 'Scrutiny Status', width: 200 },
        { field: 'totalQuantity', headerName: 'Total Quantity (in MT)', width: 140, type: "number" },
        { field: 'committedQuantity', headerName: 'Committed Quantity (in MT)', width: 140, type: "number" },
        {
            field: 'action', headerName: 'Action', width: 120, hide: getLocalStorageItem('role') === ROLES?.RegistrationScruitnizer && userType === "External",
            renderCell: (params) => {
                return (
                    <Tooltip title="Update">
                        <IconButton
                            variant="contained"
                            color="primary"
                            disabled={params?.row?.scutinyStatus !== "Approved"}
                            onClick={() => onUpdate(params?.row?.urn, params?.row?.stakeholderType, params?.row?.stakeholderSubCategory)}
                        >
                            <UpdateIcon sx={{ ml: 1 }} />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    const onUpdate = (urnSelected, stakeholderType, growerSubCategory) => {
        const userData = {
            "urnSelected": urnSelected,
            "userId": userId,
            "userType": userType

        }
        if (stakeholderType === "Transporter") {
            navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected, userType: userType } });
        }
        else if (stakeholderType === "HIT") {
            navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { data: userData, URN: urnSelected, userType: userType } });
        }
        else if (stakeholderType === "LLE") {
            navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { data: userData, URN: urnSelected, userType: userType } });
        }
        else if (stakeholderType === "Interim Storage Operator") {
            navigate("/registrationHome/dashboard/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected, userType: userType } });
        }
        else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
            navigate("/registrationHome/dashboard/registrationDetails", { state: { data: userData, URN: urnSelected, userType: userType } });
        }
        else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
            navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { data: userData, URN: urnSelected, userType: userType } });
        }
        else if (growerSubCategory === "Forest") {
            navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { data: userData, URN: urnSelected, userType: userType } });
        }
        else {
            // navigate("/registrationHome/dashboard/onView", { state: { data: userData } });
        }

    }

    return (
        <div>
            <Container fluid>
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG61</p>}


                <Row>
                    <Col xs={12} md={12}>
                        <p className='lead_header_text'>OVERVIEW</p>
                    </Col>
                </Row>
                <Row>
                    {blockScrutinizersArray.find(email => email == localStorage.getItem('email')) ? null : <Col xs={6} md={3}>
                        <div className='lead_card'>
                            <a href='' onClick={(e) => viewAllAssignedStakeholders(e, '')} style={{ color: '#005BAA', float: 'right', marginTop: '0vh' }}>View all </a>
                            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingAppCount}</Typography>
                            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Applications</Typography>
                        </div></Col>}
                    <Col xs={6} md={3}>
                        <div className='lead_card'>
                            <a href='' onClick={(e) => viewAllClarifications(e, '')} style={{ color: '#005BAA', float: 'right', marginTop: '0vh' }}>View all </a>
                            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{pendingClarificationsCount}</Typography>
                            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Applications for Clarification</Typography>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className='lead_card'>
                            <a href='' onClick={(e) => viewAllAssignedStakeholders(e, 'ResourceUpdate')} style={{ color: '#005BAA', float: 'right', marginTop: '0vh' }}>View all </a>
                            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{resourceUpdateCount}</Typography>
                            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Resource Update Applications</Typography>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className='lead_card'>
                            <a href='' onClick={(e) => viewAllClarifications(e, 'ResourceUpdate')} style={{ color: '#005BAA', float: 'right', marginTop: '0vh' }}>View all </a>
                            <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{resourceUpdatePendingClarificationCount}</Typography>
                            <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Pending Resource Update Applications for Clarification</Typography>
                        </div>
                    </Col>
                </Row>
                <Row>

                    <Col xs={12} md={12} >
                        <div className='lead-container'>
                            <p className='lead-container-text' style={{ marginTop: '3vh' }}>Mapping Details</p>
                            {mappingArray &&
                                <Box style={{ height: 500, width: '100%' }}>
                                    <DataGrid
                                        sx={{
                                            "& .MuiDataGrid-columnHeaderTitle": {
                                                whiteSpace: "normal",
                                                lineHeight: "normal"
                                            },
                                            "& .MuiDataGrid-columnHeader": {
                                                height: "unset !important"
                                            },
                                            "& .MuiDataGrid-columnHeaders": {
                                                maxHeight: "168px !important"
                                            }
                                        }}
                                        rows={mappingArray}
                                        columns={columns}
                                        pageSize={10}
                                        getRowId={(row) => row?.urn}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                    />
                                </Box>}
                        </div>
                    </Col>
                </Row>
            </Container>
            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <OTPValidationPopover onClose={handleLogModalClose} urn={urn} mobileNumber={mobileNumber} callback={onOTPValidated} />
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default RegistrationScrutiny;
